// No test coverage: no exported functions; URL values are derived from already-tested isDevEnvironment
import { isDevEnvironment } from '@/utils/env-utils.ts';

const useDevPrefix: boolean = isDevEnvironment();

const patientAppBaseUrl = `https://${useDevPrefix ? 'dev.' : ''}patients.eterno-health.io`;
const patientAppCloudBaseUrl = `https://${useDevPrefix ? 'dev.' : ''}patients.gesund.cloud/customer`;
const patientsBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}patients.eterno-health.io`;
const adminsBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}admins.eterno-health.io`;
// Practitioners base URL in Prod is `professionals` not `practitioners`, for example: https://api.professionals.eterno-health.io/public/users/availability/search
const practitionersBaseUrl = `https://api.${useDevPrefix ? 'dev.practitioners' : 'professionals'}.eterno-health.io`;
const docExtractBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}docextract.eterno-health.io`;
const recallBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}bi.eterno-health.io`;
const careviewBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}bi.eterno-health.io`;
const connectBaseUrl = `https://api.${useDevPrefix ? 'dev.' : ''}assistant.eterno-health.io`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ServiceUrl = {
    PATIENT_APP: {
        BASE: patientAppBaseUrl,
        CLOUD_BASE: patientAppCloudBaseUrl,
        ALL_FORMS_CODE: `/all-forms-code`,
        FORMS: `/forms`,
        FORMS_STATIC: `/forms/static`,
    },
    PRACTITIONER_API_DOMAIN: {
        SECURE_ADMIN: {
            USER: {
                AVAILABILITY_CACHED_DATA: `${practitionersBaseUrl}/secure-admin/users/availability/cached-data`,
            },
        },
        PUBLIC: {
            USERS: {
                AVAILABILITY: `${practitionersBaseUrl}/public/users/availability`,
            },
            MAGIC_LINK: {
                CREATE: `${practitionersBaseUrl}/public/auth/magic-link`,
            },
        },
    },
    PATIENT_API_DOMAIN: {
        SECURE_ADMIN: {
            CALL_SYSTEM_API: `${patientsBaseUrl}/secure-admin/call-system`,
            USER: {
                FORM_DATA: `${patientsBaseUrl}/secure-admin/user/form-data`,
                DOCUMENTS_DATA: `${patientsBaseUrl}/secure-admin/user/documents`,
                APPOINTMENTS: `${patientsBaseUrl}/secure-admin/user/appointments`,
                GET_APPOINTMENTS_FOR_TODAY: `${patientsBaseUrl}/secure-admin/user/appointments/today`,
                GET_APPOINTMENTS_BY_DATE_RANGE: `${patientsBaseUrl}/secure-admin/user/appointments/range`,
                UPDATE_APPOINTMENT: `${patientsBaseUrl}/secure-admin/user/appointments/update`,
                BOOK_APPOINTMENT: `${patientsBaseUrl}/secure-admin/user/appointments/book-admin`,
            },
            DOC_CIRRUS: {
                SEARCH: `${patientsBaseUrl}/secure-admin/doc-cirrus/users/search`,
                CREATE_USER: `${patientsBaseUrl}/secure-admin/doc-cirrus/user/create`,
                USERS: `${patientsBaseUrl}/secure-admin/doc-cirrus/users`,
                GET_USER: `${patientsBaseUrl}/secure-admin/doc-cirrus/users`,
                UPDATE_USER: `${patientsBaseUrl}/secure-admin/doc-cirrus/users/update`,
                CARD_READERS: `${patientsBaseUrl}/secure-admin/doc-cirrus/card-readers`,
                READ_CARD: `${patientsBaseUrl}/secure-admin/doc-cirrus/card-readers/read`,
                SCHEDULES: `${patientsBaseUrl}/secure-admin/doc-cirrus/schedules`,
                UPDATE_SCHEDULE_PARTIAL: `${patientsBaseUrl}/secure-admin/doc-cirrus/schedules/update/partial`,
            },
            DATA_CUR: {
                EVENTS: `${patientsBaseUrl}/secure-admin/data-cur/events`,
                USERS: `${patientsBaseUrl}/secure-admin/data-cur/users`,
                SEARCH: `${patientsBaseUrl}/secure-admin/data-cur/users/search`,
            },
        },
        SECURE_PRAC: {
            DOCUMENTS: `${patientsBaseUrl}/secure-prac/user/documents`,
        },
    },
    ADMIN_API_DOMAIN: {
        CRISP: {
            GET_MESSAGES: `${adminsBaseUrl}/secure-admin/crisp/messages`,
            SEND_MESSAGE: `${adminsBaseUrl}/secure-admin/crisp/messages/send`,
        },
    },
    BI_API_DOMAIN: {
        QUICKSIGHT_DASHBOARDS: `${careviewBaseUrl}/secure-prac/bi-api/careview`,
    },
    DOC_EXTRACT_API_DOMAIN: {
        APPOINTMENTS: `${docExtractBaseUrl}/secure-prac/docextract/appointments`,
        DOCUMENTS: `${docExtractBaseUrl}/secure-prac/docextract/patients/documents/data`,
    },
    RECALL_API_DOMAIN: {
        RULE_LIST: `${recallBaseUrl}/secure-prac/recall-api/rules`,
        CREATE_RULE: `${recallBaseUrl}/secure-prac/recall-api/rules`,
        GET_PREVIEW: `${recallBaseUrl}/secure-prac/recall-api/rules/preview`,
        UPDATE_STATUS: `${recallBaseUrl}/secure-prac/recall-api/rules/update-status`,
        MARKERS: `${recallBaseUrl}/secure-prac/recall-api/markers`,
    },
    CONNECT_API_DOMAIN: {
        PHONE_ASSISTANTS: `${connectBaseUrl}/secure-prac/phone-assistant/phone-numbers`,
        CLAIM: `${connectBaseUrl}/secure-prac/phone-assistant/phone-numbers/create`,
        RELEASE: `${connectBaseUrl}/secure-prac/phone-assistant/phone-numbers/delete`,
        GET_CALL_HANDLING_CONFIGS: `${connectBaseUrl}/secure-prac/phone-assistant/call-handling-configs`,
        UPDATE_CALL_HANDLING_CONFIGS: `${connectBaseUrl}/secure-prac/phone-assistant/call-handling-configs/update`,
        LOCATIONS: `${connectBaseUrl}/secure-prac/phone-assistant/locations`,
    },
};
